module.exports = __webpack_public_path__ + "img/android.6d05c5de.svg";